import { writable } from 'svelte/store';
import { v4 as uuidv4 } from 'uuid';
const init = [{ r: 255, g: 0, b: 0, a: 255, uuid: uuidv4() },
    { r: 0, g: 255, b: 0, a: 255, uuid: uuidv4() },
    { r: 0, g: 0, b: 255, a: 255, uuid: uuidv4() },
    { r: 0, g: 0, b: 0, a: 255, uuid: uuidv4() },
    { r: 255, g: 255, b: 255, a: 255, uuid: uuidv4() }];
function createActiveColorStore() {
    function setLocalStorage(color) {
        localStorage.setItem('activeColor', JSON.stringify(color));
        return color;
    }
    function getLocalStorage() {
        const color = localStorage.getItem('activeColor');
        if (color) {
            return JSON.parse(color);
        }
        return init[0];
    }
    const { subscribe, set } = writable(getLocalStorage());
    return {
        subscribe,
        set: (color) => { set(color); setLocalStorage(color); },
    };
}
function createColor() {
    return { r: 0, g: 0, b: 0, a: 255, uuid: uuidv4() };
}
function createColorListStore() {
    function setLocalStorage(colors) {
        localStorage.setItem('colorList', JSON.stringify(colors));
        return colors;
    }
    function getLocalStorage() {
        const colors = localStorage.getItem('colorList');
        if (colors) {
            return JSON.parse(colors);
        }
        return init;
    }
    const { subscribe, update } = writable(getLocalStorage());
    return {
        subscribe,
        add: () => update(colorList => setLocalStorage([...colorList, createColor()])),
        update: (color) => update(colorList => setLocalStorage(colorList.map(c => c.uuid === color.uuid ? color : c))),
        delete: (color) => update(colorList => setLocalStorage(colorList.filter(c => c.uuid !== color.uuid)))
    };
}
export const ActiveColorStore = createActiveColorStore();
export const ColorListStore = createColorListStore();
